import { render } from "./teamManage.vue?vue&type=template&id=1a06361a&scoped=true&ts=true"
import script from "./teamManage.vue?vue&type=script&lang=ts"
export * from "./teamManage.vue?vue&type=script&lang=ts"

import "./teamManage.vue?vue&type=style&index=0&id=1a06361a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a06361a"]])

export default __exports__